// extracted by mini-css-extract-plugin
export default {"community-partners":"CommunityPartner_community-partners__EzCYz"};